import { render } from "./loader.vue?vue&type=template&id=071b7a2c"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./loader.vue?vue&type=style&index=0&id=071b7a2c&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__